<template>
  <v-container>
    <v-row>
      <v-col>
        <InvoiceDocumentationForm
            ref="invoiceDocument"
            hide-button
            @closeDialog="() => {$emit('dialogClosed')}"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

import InvoiceDocumentationForm from '@/modules/book/views/task/components/InvoiceDocumentationForm';

export default {
  name: 'CreateInvoiceStep',
  components: {InvoiceDocumentationForm},
  data() {
    return {
      inputData: {}
    }
  },
  methods: {
    setInputData(inputData) {
      this.inputData = inputData;
      this.$refs.invoiceDocument.setInputData(inputData);
    },
    save() {
      this.$refs.invoiceDocument.save();
    },
    cancelDialog() {
      this.$refs.invoiceDocument.cleanForm();
      this.inputData = {}
    }
  }
}
</script>